<template>
  <div class="anagrafica-dipendenti">
    <div class="row row-custom">
      <div class="titolo-app col-lg-20 col-md-19 col-sm-17 col-1 no-padding">
        <span class="titolo-bold d-none d-sm-block">
          {{ $t('AssociaDipendneti.AssociaDipendneti').toUpperCase() }}
        </span>
      </div>
    </div>
    <div id="contenitore" class="contenitore col-24 no-padding"
         :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
      <keep-alive>
        <router-view @hideScroll="hideScroll" @showScroll="showScroll = true" :contenitoreHeight="contenitoreHeight" :prefixApp="prefixApp"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AssociaDipendneti',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    i18n: {
      messages: {
        it_IT: {
          AssociaDipendneti: {
            AssociaDipendneti: 'Registrazione Dipendenti'
          }
        },
        fr_FR: {
          AssociaDipendneti: {
            AssociaDipendneti: 'Inscription des Employés'
          }
        },
        es_ES: {
          AssociaDipendneti: {
            AssociaDipendneti: 'Registro de Empleados'
          }
        },
        de_DE: {
          AssociaDipendneti: {
            AssociaDipendneti: 'Mitarbeiterregistrierung'
          }
        },
        en_GB: {
          AssociaDipendneti: {
            AssociaDipendneti: 'Employee Registration'
          }
        }
      }
    },
    data () {
      return {
        showScroll: true,
        prefixApp: 'as'
      }
    },
    methods: {
      hideScroll: function () {
        var container = this.$el.querySelector('#contenitore')
        container.scrollTop = 0
        this.showScroll = false
      },
      indietro: function () {
        this.$router.push({name: ''})
      }
    },
    computed: {
      showIndietro: function () {
        let path = this.$route.path
        return (path.indexOf('/fornitura/richiestediofferta/dettaglio') >= 0)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../../assets/less/general.less";

  .anagrafica-dipendenti {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 55px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      padding-bottom: 10px;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: right;
      }
      .icona-menu {
        padding-left: 0px;
        padding-right: 3px;
        // padding-top: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px, @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
        // margin-top: -4px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      border-radius: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/AssociaDipendenti/AssociaDipendenti.vue